import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
// import { useLocation } from "react-router-dom";
import { useHistory } from "react-router-dom";
import collapseIcon from "../../assets/images/collapse.svg";
import { useStyles } from "../../assets/jss/DriverDetails";
import PraisoTableWrapper from "../../components/CustomComponents/PraisoTable/PraisoTableWrapper";
import { APIURL, ContentEngagementCategoryStatus, EntityAccess, RBAC_CODE, Role, TableComponentCodes } from "../../config/app-globals.enum";
import { getDriverMapPointsList } from "../../services/DriverTripMapPoints";
import { getCompaEnabledForView, getDistractionEnabledForView, getEventType, getMileageClaimsEnabled, getPageSize, getUserData, getVisibleEventDetails, setDriverIdForTC } from "../../services/LocalStorageService";
import CustomBox from "../CustomComponents/CustomBox/CustomBox";
import CustomButton from "../CustomComponents/CustomButton/CustomButton";
import CustomTab from "../CustomComponents/CustomTab/CustomTab";
import CustomTabs from "../CustomComponents/CustomTabs/CustomTabs";
import DashboardPenaltyCard from "../DashboardPenaltyCard/DashboardPenaltyCard";
import DriverDetailsTabMileageClaimDialog from "./DriverDetailsTabMileageClaimDialog";
import DriverDetailsTabTrips from "./DriverDetailsTabTrips";

export default function DriverDetailsTab(props) {

    const { t } = useTranslation();
    const classes = useStyles();
    const [eventTypes] = React.useState(getEventType);
    const [userData] = React.useState(getUserData());
    const [value, setValue] = useState(0);
    const [userId, setUserId] = useState(props.userId);
    const [showTab, setShowTab] = useState(props.showTab);
    const [statusValue, setStatusValue] = React.useState(null);
    const [alertMessage, setAlertMessage] = React.useState("");
    const [isAlertOpen, setIsAlertOpen] = React.useState(false);
    const [isApi, setIsApi] = React.useState(false);
    const [isApiFailed, setIsApiFailed] = React.useState(false);
    const [cardDetails, setCardDetails] = useState(null);
    const [tripEventList, setTripEventList] = useState(null);
    const [isCompaEnabledForView] = React.useState(getCompaEnabledForView);
    const [isDistractionEnabledForView] = React.useState(getDistractionEnabledForView);
    const [isMileageClaimsEnabled] = React.useState(getMileageClaimsEnabled);
    let [visibleEventDetails] = React.useState(getVisibleEventDetails);
    const [showDrivertripCard, setShowDrivertripCard] = useState(false);
    const history = useHistory();

    useEffect(() => {
        setUserId(props.userId);
        setDriverIdForTC(userId);
    }, [props.userId]);

    const [brakingData, setBrakingData] = useState({
        loading: true,
        data: [],
        currentPageNo: 0,
        totalRows: 0,
        rowsToShow: getPageSize(),
    });

    const [corneringData, setCorneringData] = useState({
        loading: true,
        data: [],
        currentPageNo: 0,
        totalRows: 0,
        rowsToShow: getPageSize(),
    });

    const [speedingData, setSpeedingData] = useState({
        loading: true,
        data: [],
        speedingSorted: [],
        currentPageNo: 0,
        totalRows: 0,
        rowsToShow: getPageSize(),
    });

    const [changes, setChanges] = useState({
        rowChanged: false,
        paginationFlow: "",
        brakingPage: 1,
        corneringPage: 1,
        speedingPage: 1,
        distractionPage: 1
    });

    const [distractionData, setDistractionData] = useState({
        loading: true,
        data: [],
        currentPageNo: 0,
        totalRows: 0,
        rowsToShow: getPageSize(),
    });

    const [accelerationData, setAccelerationData] = useState({
        loading: true,
        data: [],
        currentPageNo: 0,
        totalRows: 0,
        rowsToShow: getPageSize(),
    });

    function resetBraking() {
        setBrakingData({
            loading: true,
            data: [],
            currentPageNo: 0,
            totalRows: 0,
            rowsToShow: getPageSize(),
        });
    }

    function resetCornering() {
        setCorneringData({
            loading: true,
            data: [],
            currentPageNo: 0,
            totalRows: 0,
            rowsToShow: getPageSize(),
        });
    }

    function resetSpeeding() {
        setSpeedingData({
            loading: true,
            data: [],
            speedingSorted: [],
            currentPageNo: 0,
            totalRows: 0,
            rowsToShow: getPageSize(),
        });
    }

    function resetDistraction() {
        setDistractionData({
            loading: true,
            data: [],
            currentPageNo: 0,
            totalRows: 0,
            rowsToShow: getPageSize(),
        });
    }

    function resetAcceleration() {
        setAccelerationData({
            loading: true,
            data: [],
            currentPageNo: 0,
            totalRows: 0,
            rowsToShow: getPageSize(),
        });
    }

    useEffect(() => {
        if (showTab === "BRAKING") {
            resetCornering();
            resetSpeeding();
            resetDistraction();
            resetAcceleration();
            setValue(1);
            props.handleExpandView(true);
        } else if (showTab === "CORNERING") {
            resetBraking();
            resetSpeeding();
            resetDistraction();
            resetAcceleration();
            setValue(2);
            props.handleExpandView(true);
        } else if (showTab === "SPEEDING") {
            resetCornering();
            resetBraking();
            resetDistraction();
            resetAcceleration();
            setValue(0);
            props.handleExpandView(true);
        } else if (showTab === "ACCELERATION") {
            resetCornering();
            resetBraking();
            resetSpeeding();
            resetDistraction();
            setValue(3);
            props.handleExpandView(true);
        }
        else if (showTab === "DISTRACTION") {
            resetCornering();
            resetBraking();
            resetSpeeding();
            resetAcceleration();
            setValue(4);
            props.handleExpandView(true);
        } else if (showTab === "TRIPS") {
            resetCornering();
            resetBraking();
            resetSpeeding();
            resetDistraction();
            setValue(5);
        } else if (showTab === "ENGAGEMENT") {
            resetCornering();
            resetBraking();
            resetSpeeding();
            resetDistraction();
            setValue(6);
        } else if (showTab === "MILEAGE_CLAIMS") {
            resetCornering();
            resetBraking();
            resetSpeeding();
            resetDistraction();
            setValue(7);
        }
        props.setShowTab(showTab);
    }, [userId, showTab, changes]);

    const handleTabs = (event, value) => {
        const _showTab = value;
        if (showTab === _showTab) return;
        setChanges({ ...changes, paginationFlow: "" });
        setShowTab(_showTab);
        setValue(value);
        const isImporsonation = history.location.pathname.includes("impersonation");
        isImporsonation ? history.replace(`/impersonation/${userId}/userdetails/${userId}#${value}`)
            : history.replace(`/userdetails/${userId}/#${value}`);
    };

    function a11yProps(index) {
        return {
            id: `simple-tab-${index}`,
            "aria-controls": `simple-tabpanel-${index}`,
        };
    }
    function TabPanel(props) {
        const { children, value, index, ...other } = props;
        return (
            <div
                role="tabpanel"
                hidden={value !== index}
                id={`simple-tabpanel-${index}`}
                aria-labelledby={`simple-tab-${index}`}
                {...other}
            >
                {value === index && <CustomBox m={3}>{children}</CustomBox>}
            </div>
        );
    }
    TabPanel.propTypes = {
        children: PropTypes.node,
        index: PropTypes.any.isRequired,
        value: PropTypes.any.isRequired,
    };

    const [eventWithId, setEventWithId] = useState(null);
    React.useEffect(() => {
        if (eventTypes && eventTypes.length) {
            let eventWithIdObj = {}
            eventTypes.forEach((item, index) => {
                if (item.code) {
                    eventWithIdObj[item.code] = item.id
                }
            })
            setEventWithId(eventWithIdObj)
        }
    }, [eventTypes])

    let handleDriverClick = async (param) => {
        if (param && param.tripId && param.userId) {
            setStatusValue(null);
            setAlertMessage("");
            setIsAlertOpen(false);
            setIsApi(true);

            const data = await getDriverMapPointsList(param);
            if (
                data &&
                (data.status.code === 0 ||
                    data.status.code === 200 ||
                    data.status.code === 201) &&
                data.content && data.content.tripLocationList && data.content.tripLocationList.length > 0
            ) {
                setIsApi(false);
                if (data.content.tripLocationList && data.content.tripLocationList.length > 0) {
                    setTripEventList(data.content);
                }
                setCardDetails(param);
                setShowDrivertripCard(true);
            } else {
                setIsApiFailed(true);
                setIsApi(false);
                changeApiStatusCodeFunc(data.status);
            }
        }
    }

    const changeApiStatusCodeFunc = (status) => {
        if (
            status.code &&
            status.code !== 0 &&
            status.code !== 200 &&
            status.code !== 201
        ) {
            setStatusValue(status.code);
            setAlertMessage(
                status.message
                    ? status.message
                    : `${t("SOMETHING_WENT_WRONG_PLEASE_TRY_AGAIN_LATER")}`
            );
            setIsAlertOpen(true);
        }
    };

    const [trigger, setTrigger] = useState(false);
    const [showDriverDetailsTabMileageClaimDialog, setShowDriverDetailsTabMileageClaimDialog] = useState(false);
    const handleCloseShowDriverDetailsTabMileageClaimDialog = (refreshList: boolean) => {
        if (refreshList) {
            setTrigger(!trigger);
        }
        setShowDriverDetailsTabMileageClaimDialog(false);
    }

    return (
        <CustomBox>
            <CustomTabs value={showTab} onChange={handleTabs} aria-label="simple tabs example" indicatorColor="primary" className={classes.tabs} style={{ minWidth: "500px" }} >
                {visibleEventDetails && visibleEventDetails.length > 0 ? visibleEventDetails.map(tab =>
                    <CustomTab key={tab} value={tab} label={t(tab)} {...a11yProps(visibleEventDetails.indexOf(tab))} />
                ) : (
                    <>
                        <CustomTab label={t("SPEEDING")} {...a11yProps("SPEEDING")} />
                        <CustomTab label={t("BRAKING")} {...a11yProps("BRAKING")} />
                        <CustomTab label={t("CORNERING")} {...a11yProps("CORNERING")} />
                        <CustomTab label={t("ACCELERATION")} {...a11yProps("ACCELERATION")} />
                        {isDistractionEnabledForView && isDistractionEnabledForView === EntityAccess.ALLOWED &&
                            <CustomTab label={t("DISTRACTION")} {...a11yProps("DISTRACTION")} />}
                        {isCompaEnabledForView && isCompaEnabledForView === EntityAccess.ALLOWED &&
                            <CustomTab label={t("TRIPS")} {...a11yProps("TRIPS")} />}
                    </>
                )}
                <CustomTab key={"ENGAGEMENT"} value={"ENGAGEMENT"} label={t("ENGAGEMENT")} {...a11yProps(visibleEventDetails.length)} />
                {isMileageClaimsEnabled && isMileageClaimsEnabled === EntityAccess.ALLOWED &&
                    <CustomTab key={"MILEAGE_CLAIMS"} value={"MILEAGE_CLAIMS"} label={t("MILEAGE_CLAIMS")} {...a11yProps("MILEAGE_CLAIMS")} />}
            </CustomTabs>
            {showTab === "SPEEDING" || showTab === "DRIVER_DISTRACTION" ?
                <CustomBox style={{ marginTop: '10px' }}>
                    <DashboardPenaltyCard
                        eventTypes={eventTypes}
                        eventCode={showTab}
                    />
                </CustomBox>
                : null}
            <CustomBox hidden={showTab !== "SPEEDING"} className={classes.tabPanel} >
                {showTab === "SPEEDING" && eventTypes && eventTypes.length && eventWithId && userId ?
                    (<PraisoTableWrapper
                        // getTableSettingAPI="/tableSettingApi" 
                        // tableSettingView="speedingEventList" 
                        getTableSettingAPI={`user-table-component-mapping/v1/fetchAll?tcCode=${TableComponentCodes.SPEEDING_EVENT_LIST}`}
                        tableSettingView={TableComponentCodes.SPEEDING_EVENT_LIST}
                        getTableDataAPI={`insights/speed-event`}
                        getTableDataApiParam={{ eventTypeId: eventWithId['SPEEDING'], userId: userId, }}
                        tableDataApiResponseProperty="eventDetails"
                        {...props}
                    />)
                    :
                    null}
            </CustomBox>
            <CustomBox hidden={showTab !== "BRAKING"} className={classes.tabPanel} >
                {showTab === "BRAKING" && eventTypes && eventTypes.length && eventWithId && userId ? (
                    <PraisoTableWrapper
                        //getTableSettingAPI="/tableSettingApi" 
                        // tableSettingView="brakingEventList" 
                        getTableSettingAPI={`user-table-component-mapping/v1/fetchAll?tcCode=${TableComponentCodes.BRAKING_EVENT_LIST}`}
                        tableSettingView={TableComponentCodes.BRAKING_EVENT_LIST}
                        getTableDataAPI={`insights/event-details/${eventWithId['BRAKING']}`}
                        getTableDataApiParam={{ userId: userId }}
                        tableDataApiResponseProperty="eventDetails"
                        {...props} />
                ) : null}
            </CustomBox>
            <CustomBox hidden={showTab !== "CORNERING"} className={classes.tabPanel} >
                {showTab === "CORNERING" && eventTypes && eventTypes.length && eventWithId && userId ? (
                    <PraisoTableWrapper
                        //getTableSettingAPI="/tableSettingApi" 
                        // tableSettingView="corneringEventList" 
                        getTableSettingAPI={`user-table-component-mapping/v1/fetchAll?tcCode=${TableComponentCodes.CORNERING_EVENT_LIST}`}
                        tableSettingView={TableComponentCodes.CORNERING_EVENT_LIST}
                        getTableDataAPI={`insights/event-details/${eventWithId['CORNERING']}`}
                        getTableDataApiParam={{ userId: userId }}
                        tableDataApiResponseProperty="eventDetails"
                        {...props} />
                ) : null}
            </CustomBox>
            <CustomBox hidden={showTab !== "ACCELERATION"} className={classes.tabPanel} >
                {showTab === "ACCELERATION" && eventTypes && eventTypes.length && eventWithId && userId ? (
                    <PraisoTableWrapper
                        //getTableSettingAPI="/tableSettingApi" 
                        // tableSettingView="distractionEventList" 
                        getTableSettingAPI={`user-table-component-mapping/v1/fetchAll?tcCode=${TableComponentCodes.ACCELERATION_EVENT_LIST}`}
                        tableSettingView={TableComponentCodes.ACCELERATION_EVENT_LIST}
                        getTableDataAPI={`insights/event-details/${eventWithId['ACCELERATION']}`}
                        getTableDataApiParam={{ userId: userId }}
                        tableDataApiResponseProperty="eventDetails"
                        {...props} />
                ) : null}
            </CustomBox>
            <CustomBox hidden={showTab !== "DRIVER_DISTRACTION"} className={classes.tabPanel} >
                {showTab === "DRIVER_DISTRACTION" && eventTypes && eventTypes.length && eventWithId && userId ? (
                    <PraisoTableWrapper
                        //getTableSettingAPI="/tableSettingApi" 
                        // tableSettingView="distractionEventList" 
                        getTableSettingAPI={`user-table-component-mapping/v1/fetchAll?tcCode=${TableComponentCodes.DISTRACTION_EVENT_LIST}`}
                        tableSettingView={TableComponentCodes.DISTRACTION_EVENT_LIST}
                        getTableDataAPI={`insights/distraction-list`}
                        getTableDataApiParam={{ eventTypeId: eventWithId['DRIVER_DISTRACTION'], userId: userId }}
                        tableDataApiResponseProperty="distractionEventDetails"
                        {...props} />
                ) : null}
            </CustomBox>
            <CustomBox hidden={showTab !== "TRIPS"} className={classes.tabPanel}>
                {showTab === "TRIPS" ? (
                    <>
                        <CustomBox textAlign="right" style={{ minHeight: '30px' }}>
                            {!props.isExpandView && <CustomButton className={classes.actionExpandCollapseBtn} onClick={async () => props.handleExpandView(true)}>
                                {t('COLLAPSE_VIEW')}
                                <img className={classes.imageIcon} src={collapseIcon} />
                            </CustomButton>}
                        </CustomBox>
                        <DriverDetailsTabTrips {...props} eventTypes={eventTypes} userId={props.userId} />
                    </>
                ) : null}
            </CustomBox>
            <CustomBox hidden={showTab !== "ENGAGEMENT"} className={classes.tabPanel} >
                {showTab === "ENGAGEMENT" ? (
                    <PraisoTableWrapper
                        getTableSettingAPI={`user-table-component-mapping/v1/fetchAll?tcCode=${TableComponentCodes.CONTENT_ENGAGEMENT}`}
                        tableSettingView={TableComponentCodes.CONTENT_ENGAGEMENT}
                        getTableDataAPI={`${APIURL.CONTENT_USER_LIST_API}${ContentEngagementCategoryStatus.SINGLE_DRIVER}}`}
                        getTableDataApiParam={{ userId: props.userId }}
                        hideGlobalFilter={1}
                        hidePagination={1}
                        isRowExpanded={1}
                        isHideTableSelector={1}
                        tableAccordion={{
                            component: "ContentEngagementTab",
                            componentProps: { userId: "userId", isExpanded: true },
                            access: {
                                viewEntity: RBAC_CODE.CE_ACCORDION_VIEW,
                                accessUserId: "userId",
                            },
                        }}
                        {...props} />
                ) : null}
            </CustomBox>
            <CustomBox hidden={showTab !== "MILEAGE_CLAIMS"} className={classes.tabPanel} >
                {showTab === "MILEAGE_CLAIMS" ? (
                    <>
                        {userData && userData.userRoleId === Role.DRIVER &&
                            <CustomBox textAlign="right" style={{ marginBottom: '-14px' }}>
                                <CustomButton onClick={() => setShowDriverDetailsTabMileageClaimDialog(true)}>{t('CLAIM_MILEAGE_EXPENSES')}</CustomButton>
                            </CustomBox>
                        }
                        <PraisoTableWrapper
                            getTableSettingAPI={`user-table-component-mapping/v1/fetchAll?tcCode=${TableComponentCodes.DRIVER_MILEAGE_CLAIM_LIST}`}
                            tableSettingView={TableComponentCodes.DRIVER_MILEAGE_CLAIM_LIST}
                            getTableDataAPI={`${APIURL.GET_MILEAGE_CLAIM_LIST}`}
                            getTableDataApiParam={{ userId: props.userId }}
                            tableDataApiResponseProperty="mileageClaimList"
                            trigger={trigger}
                            {...props} />

                        {
                            showDriverDetailsTabMileageClaimDialog &&
                            <DriverDetailsTabMileageClaimDialog {...props} handleCloseShowDriverDetailsTabMileageClaimDialog={handleCloseShowDriverDetailsTabMileageClaimDialog} />
                        }
                    </>
                ) : null}
            </CustomBox>
        </CustomBox>
    );
}
